import {useMutation, useQueryClient} from '@tanstack/react-query'
import {SIGN_UP_REQUESTS_API} from '@/features/signup-requests/services/signupRequests.http.ts'
import {MUTATION_KEYS, QUERY_KEYS} from '@/features/signup-requests/keys.ts'
import {AxiosError} from 'axios'
import {handleGenericError} from '@utilities/helpers.ts'
import {useTranslation} from 'react-i18next'

export const useSwitchToAutoApprove = () => {
    const queryClient = useQueryClient()
    const {t} = useTranslation()

    return useMutation({
        mutationKey: [MUTATION_KEYS.SWITCH_AUTO_APPROVE],
        mutationFn: (payload: {status: boolean; userID: number}) => SIGN_UP_REQUESTS_API.switchAutoApprove(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ADMIN_CONFIG]})
        },
        onError: error => {
            const errorObject = error as AxiosError
            handleGenericError({error: errorObject, t})
        }
    })
}
